<div :class="'Slide ' + dynamicClass">


    <div class="Slide__Inner">
        <slot />
    </div>

</div>
